import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { ModalpopService } from '../modalpop.service';
import { Router } from '@angular/router';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { MatDialogRef } from '@angular/material/dialog';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { environment } from 'src/environments/environment';
import { log } from 'console';
import { element } from 'protractor';
import { MatDialog } from '@angular/material/dialog';
import { FeeTempletDialogBoxComponent } from '../fee-templet-dialog-box/fee-templet-dialog-box.component';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-fee-templet',
  templateUrl: './fee-templet.component.html',
  styleUrls: ['./fee-templet.component.scss']
})
export class FeeTempletComponent implements OnInit {
  feeTempletForm: FormGroup;
  list;
  FeeTempletList: any;
  APIService: string;
  Table = true;
  filteredSR: any;
  FeeHeadList: any;
  filteredHeadList: any;
  myFormValueChanges;
  FeeTable: any;
  lvl: 0;
  FeesTable = [];
  feeList: any;
  headdList: any[] = [];
  FeeTemplateSearch: FormGroup;
  feeTempList: any;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 20];
  currentPage = 1;
  totalItems = 0;
  AdmissionFee = true;
  ExamFee = false;
  FeesTemplate = '';
  ExamListBtn = false;
  AdmListBtn = true;
  TclcListBtn = false;
  TclcFee= false;
  TCList: any;
  filterTCList: any;
  TC: boolean;
  LC: boolean;
  MC: boolean;
  userPermission
  setIntervalSearch: any;
  constructor(public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private dialog: MatDialog,
    private fb: FormBuilder, public router: Router, private httpClient: HttpClient,
    private spinner: NgxSpinnerService) { this.APIService = environment.serviceUrl; }
  dialogRef: MatDialogRef<any>;
  ngOnInit(): void {
    this.FeesTemplate = 'Registration Fees Template'
    this.AdmissionFee = true;
    this.ExamFee = false;
    this.AdmListBtn = false;
    this.ExamListBtn = true;
    this.TclcListBtn = false;
    window.scroll(0, 0);
    this.list = true;
    this.feeTempletForm = this.fb.group({
      radio: new FormControl('AF'),
      tclc: new FormControl(''),
    });
    this.getFeeTempletData('AF');
    this.FeeTemplateSearch = this.fb.group({
      SearchString: new FormControl(''),
    });

    this.fetchTcLcMc();
  }

  keypress() {
    if(this.setIntervalSearch){
      clearTimeout(this.setIntervalSearch);
    }
    this.setIntervalSearch = setTimeout(()=>{
      this.FeeTempletList = [];
    let payload = {}
    payload['FeeType'] = this.feeTempletForm.value['radio'];
    payload['SearchString'] = this.FeeTemplateSearch.value['SearchString'];
    payload['PageSize'] = this.pageSize;
    if (payload['SearchString'] === "") {
      payload['PageNumber'] = this.currentPage;
    } else {
      payload['PageNumber'] = 1;
    }
    this.umsService.searchFeeTemplate(payload).subscribe(
      (res) => {
        this.FeeTempletList = res.data;
      }, (ERROR: HttpErrorResponse) => {
        this.FeeTempletList = [];
      });
    },1000)
   
  }
  onPageChange(event: PageEvent, value): void {
    this.pageSize = event.pageSize;
    const newPageIndex = Math.floor(event.pageSize * event.pageIndex / this.pageSize);
    // const newPageIndex = event.pageIndex + 1;
    this.currentPage = newPageIndex;
    if (value == 'AF') {
      this.feeTempletForm.controls['radio'].setValue('AF')
      this.getFeeTempletData('AF');
    }
    else if (value == 'EF') {
      this.feeTempletForm.controls['radio'].setValue('EF')
      this.getFeeTempletData('EF');
    }
    else if(value == 'TC') {
      this.feeTempletForm.controls['tclc'].setValue('TC')
      this.getFeeTclc('TC');
    }
    else if(value == 'LC') {
      this.feeTempletForm.controls['tclc'].setValue('LC')
      this.getFeeTclc('LC');
    }
    else if(value == 'MC') {
      this.feeTempletForm.controls['tclc'].setValue('MC')
      this.getFeeTclc('MC');
    }

  }
  getFeeTempletData(FType) {
    this.FeeTempletList = [];
    this.spinner.show();
    const payload = {};
    payload['PageSize'] = this.pageSize;
    payload['PageNumber'] = this.currentPage;
    payload['FeeType'] = FType;
    this.umsService.getFeeTemplet(payload).subscribe(res => {
      if(res.status){
        this.spinner.hide();
        this.FeeTempletList = res.data;
        this.totalItems = res.data[0].TotalRecords;
      }
      else{
        this.spinner.hide();
        this.FeeTempletList = [];
        this.totalItems = 0;
      }
    },(ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.FeeTempletList = [];
        this.totalItems = 0;
    });
  }

  addnewrecord() {
    const dialogRef = this.dialog.open(FeeTempletDialogBoxComponent, {
      width: '1000px',
      data: { key: "New" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data here
      // this.getFeeTempletData('AF');
      this.FeesTemplate = 'Registration Fees Template'
      this.AdmissionFee = true;
      this.ExamFee = false;
      this.TC = false;
      this.LC = false;
      this.MC = false;
      this.TclcFee = false;
      this.AdmListBtn = false;
      this.ExamListBtn = true;
      this.TclcListBtn = false;
      this.getFeeTempletData(this.feeTempletForm.value['radio']);
      this.FeeTemplateSearch.controls['SearchString'].setValue('');
      this.feeTempletForm.controls['tclc'].setValue('');
    });
  }

  editData(k) {
    const dialogRef = this.dialog.open(FeeTempletDialogBoxComponent, {
      width: '1000px',
      data: { selected: k, key: "Edit" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data 
      // this.feeTempletForm.controls['radio'].setValue('AF')
      this.FeesTemplate = 'Registration Fees Template'
      this.AdmissionFee = true;
      this.ExamFee = false;
      this.TC = false;
      this.LC = false;
      this.MC = false;
      this.TclcFee = false;
      this.AdmListBtn = true;
      this.ExamListBtn = false;
      this.TclcListBtn = false;
      this.getFeeTempletData(this.feeTempletForm.value['radio']);
      this.FeeTemplateSearch.controls['SearchString'].setValue('');
      this.feeTempletForm.controls['tclc'].setValue('');
      
    });
  }
  deleteData(k) {
    const dialogRef = this.dialog.open(FeeTempletDialogBoxComponent, {
      width: '1000px',
      data: { selected: k, key: "Delete" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data here
      // this.getFeeTempletData('AF');
      // this.feeTempletForm.controls['radio'].setValue('AF')
      this.FeesTemplate = 'Registration Fees Template'
      this.AdmissionFee = true;
      this.ExamFee = false;
      this.TC = false;
      this.LC = false;
      this.MC = false;
      this.TclcFee = false;
      this.AdmListBtn = true;
      this.ExamListBtn = false;
      this.TclcListBtn = false;
      this.getFeeTempletData(this.feeTempletForm.value['radio']);
      this.FeeTemplateSearch.controls['SearchString'].setValue('');
      this.feeTempletForm.controls['tclc'].setValue('');
    });
  }

  ExamList() {
    this.AdmissionFee = false;
    this.ExamFee = true;
    this.TC = false;
    this.LC = false;
    this.MC = false;
    this.TclcListBtn = false;
    this.FeesTemplate = 'Exam Fees Template'
    this.AdmListBtn = false;
    this.ExamListBtn = true;
    this.TclcFee = false;
    this.getFeeTempletData('EF')
    this.feeTempletForm.controls['tclc'].setValue('');
  }

  AdmList() {
    this.AdmListBtn = true;
    this.ExamListBtn = false;
    this.TclcListBtn = false;
    this.ExamFee = false;
    this.TC = false;
    this.LC = false;
    this.MC = false;
    this.AdmissionFee = true;
    this.TclcFee = false;
    this.FeesTemplate = 'Registration Fees Template'
    this.getFeeTempletData('AF')
    this.feeTempletForm.controls['tclc'].setValue('');
  }

  TclcList(Type){
    this.TclcListBtn = true;
    this.AdmListBtn = false;
    this.ExamListBtn = false;
    this.ExamFee = false;
    this.AdmissionFee = false;
    this.TclcFee = true
    // this.getFeeTempletData(this.feeTempletForm.value['']);
    this.feeTempletForm.controls['radio'].setValue('');
    this.FeesTemplate = 'TC/LC Fees Template'
    if(Type == 'TC'){
      this.TC = true;
      this.LC = false;
      this.MC = false;
    }
    else if(Type == 'LC'){
      this.TC = false;
      this.LC = true;
      this.MC = false;
    }
    else if(Type == 'MC'){
      this.TC = false;
      this.LC = false;
      this.MC = true;
    }
    this.getFeeTclc(Type);
  }

  
  getFeeTclc(Type){
    this.FeeTempletList = [];
    this.spinner.show();
    const payload = {};
    this.spinner.hide();
    payload['FeeType'] = Type;
    this.feeTempletForm.controls['radio'].setValue('');
    this.umsService.getFeeTclc(payload).subscribe(res => {
      if(res.status){
        this.spinner.hide();
        this.FeeTempletList = res.data;
        this.totalItems = res.data[0].TotalRecords;
      }
      else{
        this.spinner.hide();
        this.FeeTempletList = [];
        this.totalItems = 0;
      }
    },(ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.FeeTempletList = [];
        this.totalItems = 0;
    });
  }

  fetchTcLcMc() {
    this.spinner.show()
    const payload = {};
    payload['CdType'] = 'RF';
    // this.feeTempletForm.controls['radio'].setValue(null);
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.TCList = res.data;
        this.filterTCList = this.TCList.slice();
      } else {
        this.spinner.hide()
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }
  download() {

  const payload: any = {
    PageSize: 100000,
    PageNumber: 1,
    SearchString: this.FeeTemplateSearch.value['SearchString'] || '',
    FeeType:
      this.feeTempletForm.value['radio'] ||
      this.feeTempletForm.value['tclc']
  };

  this.spinner.show();

  this.umsService.searchFeeTemplate(payload).subscribe(
    (res) => {
      this.spinner.hide();

      if (!res.status || !res.data || res.data.length === 0) {
        return;
      }

      const extractedData = res.data.map(element => ({
        'Template Code': element.TemplateCode,
        'Template Name': element.TemplateName,
        'Exam': element.EmName,
        'Student Type': element.StudentTypeDesc,
        'Student Status': element.StudentStatusDesc,
        'Cast': element.CasteDesc,
        'Total Amount': element.TotalFeeAmount
      }));

      const csvContent = this.convertArrayToCSV(extractedData);
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'Fee_Template_Report.csv';
      link.click();
      window.URL.revokeObjectURL(url);
    },
    () => {
      this.spinner.hide();
    }
  );
}


 convertArrayToCSV(array: any[]) {
  const header = Object.keys(array[0]).join(',');
  const rows = array.map(obj =>
    Object.values(obj)
      .map(value => `"${value ?? ''}"`)
      .join(',')
  );
  return [header, ...rows].join('\n');
}

}





